/*
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:40
 * @LastEditors: betwaym 848032671@qq.com
 * @LastEditTime: 2024-01-29 13:38:21
 * @FilePath: \mrc-base-server-view\src\lang\index.js
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import vuetify from './vuetify'
import ls from '@/utils/Ls';
Vue.use(VueI18n)
// 给$t 加 个逻辑    如果没有匹配到对应的key的value就不显示   之前是没有匹配到对应的key的value就显示key
// Vue.prototype.$t = function(key) {
//     var values = [],
//         len = arguments.length - 1;
//     while (len-- > 0) values[len] = arguments[len + 1];

//     var i18n = this.$i18n;
//     return i18n._t.apply(i18n, [key, i18n.locale, i18n._getMessages(), this].concat(values)) == key ?
//         '' :
//         i18n._t.apply(i18n, [key, i18n.locale, i18n._getMessages(), this].concat(values)) + '--' + key
// };
// navigator.language || navigator.userLanguage //常规浏览器语言和IE浏览器
let lang = ls.get('localeLanguage') || '';
const DEFAULT_LANG = lang
const LOCALE_KEY = 'localeLanguage'

const localeslist = JSON.parse(ls.get('currentCompanyLanguage'))
let keys = {}
if (localeslist) {
    const value = localeslist.map(item => {
        return item.value
    })
    keys = {}
    value.forEach(item => {
        keys[item] = { $vuetify: vuetify[item] }
    })
} else {
    keys = {
        en: {
            $vuetify: vuetify.en
        },
        'zh-ch': {
            $vuetify: vuetify.zh
        },
        'zh-hk': {},
        de: {},
        fr: {},
        ja: {}
    }
}



const i18n = new VueI18n({
    locale: DEFAULT_LANG,
    messages: keys,
    silentTranslationWarn: true
})


export const setup_locale = lang => {
    if (!!lang) {
        lang = ls.get(LOCALE_KEY)
        if (keys[lang] === undefined) {
            lang = DEFAULT_LANG
        }
    }
    ls.set(LOCALE_KEY, lang)
    Vue.config.lang = lang
    i18n.locale = lang
}
setup_locale(ls.get(LOCALE_KEY) || DEFAULT_LANG)
export default i18n